import React__default, { createContext, useContext } from 'react';

const GlobalTranslationContext = createContext(undefined);
const GlobalTranslationContextProvider = ({ globalTranslation, children }) => {
    return (React__default.createElement(GlobalTranslationContext.Provider, { value: globalTranslation }, children));
};
const useGlobalTranslation = () => {
    return useContext(GlobalTranslationContext);
};

export { GlobalTranslationContext, GlobalTranslationContextProvider, useGlobalTranslation as default };
//# sourceMappingURL=useGlobalTranslation.js.map
